import { useQuery } from 'react-query';
import { getPostByIdService } from '../redux/services/postService';
import HookTypes from '../redux/types/hooks';

const useHook = (id: string | null) => {
  return useQuery(
    [HookTypes.post, id],
    async () => {
      if (!id) {
        return null;
      }

      const post = await getPostByIdService(id);
      return post;
    },
    {
      enabled: !!id,
    }
  );
};

export default useHook;
